/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { getEnterpriseAdminDashboardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { BoardMenuVisTemplate } from 'app/scripts/views/templates/BoardMenuVisTemplate';
import { CantAddBoardToEntTemplate } from 'app/scripts/views/templates/CantAddBoardToEntTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface BoardEntSelectPermLevelView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class BoardEntSelectPermLevelView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'change visibility';

    // @ts-expect-error TS(2339): Property 'tagName' does not exist on type 'BoardEn... Remove this comment to see the full error message
    this.prototype.tagName = 'ul';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'BoardEnt... Remove this comment to see the full error message
    this.prototype.events = { 'click .js-select': 'selectVis' };

    // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Board... Remove this comment to see the full error message
    this.prototype.className = 'pop-over-list';
  }

  render() {
    const enterprise = this.options.enterprise;

    if (
      !enterprise.canSetTeamlessBoardVisibility('private') &&
      !enterprise.canSetTeamlessBoardVisibility('public')
    ) {
      const data = {
        isEntAdmin: enterprise.isAdmin(Auth.me()),
        entSettingsUrl: getEnterpriseAdminDashboardUrl(enterprise, 'settings'),
        enterprise: enterprise.toJSON(),
      };
      this.$el.html(templates.fill(CantAddBoardToEntTemplate, data));
    } else {
      const current = this.model.getPref('permissionLevel');

      this.$el.html(
        BoardMenuVisTemplate({
          current,
          canChange: true,
          mustChange: !enterprise.canSetTeamlessBoardVisibility(current),
          hasOrg: false,
          hasSuperAdmins: false,
          privateRestricted: !enterprise.canSetTeamlessBoardVisibility(
            'private',
          ),
          orgRestricted: true,
          enterpriseRestricted: true,
          publicRestricted: !enterprise.canSetTeamlessBoardVisibility('public'),
          hasEnterprise: true,
          enterpriseName: enterprise.get('displayName'),
          isTemplate: this.model.isTemplate(),
          isOrgPremium: false,
          isTeamlessOwnedBoard: true,
        }),
      );
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectVis(e: any) {
    stopPropagationAndPreventDefault(e);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $target = $(e.target).closest('.js-select');

    if (
      $target.hasClass('disabled') ||
      $target.closest('.js-disabled').length
    ) {
      return;
    }

    const traceId = Analytics.startTask({
      taskName: 'edit-board/idOrganization',
      // @ts-expect-error TS(2322): Type '"boardEntSelectPermLevelInlineDialog"' is no... Remove this comment to see the full error message
      source: 'boardEntSelectPermLevelInlineDialog',
    });

    const setting = $target.attr('name');

    if (this.options.idOrganizationSource) {
      this.modelCache
        .get('Organization', this.options.idOrganizationSource)
        ?.boardList.remove(this.model);
    }
    this.model.update(
      {
        traceId,
        idOrganization: null,
        'prefs/permissionLevel': setting,
      },
      tracingCallback({
        taskName: 'edit-board/idOrganization',
        // @ts-expect-error TS(2322): Type '"boardEntSelectPermLevelInlineDialog"' is no... Remove this comment to see the full error message
        source: 'boardEntSelectPermLevelInlineDialog',
        traceId,
      }),
    );

    return PopOver.hide();
  }
}

BoardEntSelectPermLevelView.initClass();
export { BoardEntSelectPermLevelView };
